import $ from 'jquery';
import { showSidebarTab } from '~src/sidebarLegacy';
import { getState, unsetState } from '~src/state';
import { toggleSaveNavMenu } from '~core/navbar';
import { getGlobalControlsManager } from '~core/customControls';

export default function stopExpand(tabTargetId) {
  const selection = getState('expandSelection');
  if (selection) {
    window.canvas.setActiveObject(selection);
  }
  unsetState('isExpandActive');
  unsetState('expandCoordinates');
  unsetState('stopKeyboardListener');
  unsetState('expandSelection');
  if (!tabTargetId) {
    showSidebarTab('edit-images-ai');
  }
  const initialCanvasZoom = getState('initialCanvasZoom');
  $('#canvas-zoom').css('transform', `scale(${initialCanvasZoom})`);
  $('#editor-zoom-controls').show();
  $('#drawing-expand-canvas').fadeOut(() => {
    $('#main-canvas-container').fadeIn();
    $('#canvas').removeClass('locked').show();
    try {
      const cm = getGlobalControlsManager();
      const obj = getState('expandSelection');
      // Show floating controls again for current selection
      if (cm && obj) cm.showControl(obj);
    } catch (e) {
      console.error('Failed showing control after expand stop', e);
    }
  });
  window.expandDrawingCanvas.clear();
  window.expandDrawingCanvas.dispose();
  window.expandDrawingCanvas = null;
  toggleSaveNavMenu();

  $('.sidebar-item-grid-box-click-listener').off('click');
  $('#editor-menu-exec-ai-expand').prop('disabled', true);
  $('#editor-menu-apply-ai-expand').prop('disabled', true);
}
